export const EXPLORE_ALL_LABEL = 'All'

/** UI-only map: shortens verbose `master_industries.name` values for chips & footer. */
export const INDUSTRY_LABEL_OVERRIDES: Record<string, string> = {
  'Technology/Software': 'Tech',
  'Healthcare/Medical': 'HealthTech',
  'Finance/Banking/Insurance': 'FinTech',
  'Education/EdTech': 'EdTech',
  'Retail/E-Commerce': 'E-Commerce',
  'Marketing/Advertising/Media': 'Marketing',
}

export function shortIndustryLabel(name: string): string {
  return INDUSTRY_LABEL_OVERRIDES[name] ?? name
}

/**
 * Footer category links — industry values must match active
 * `master_industries.name` values (the explore filter chips). The old flat
 * names (Technology/Software, etc.) were deactivated when the sub-industry
 * taxonomy landed, so they no longer match anything and the links came up empty.
 */
export const FOOTER_EXPLORE_CATEGORIES = [
  { industry: 'AI & GenAI' },
  { industry: 'FinTech' },
  { industry: 'HealthTech' },
  { industry: 'E-Commerce' },
  { industry: 'EdTech' },
] as const

export function exploreIndustryHref(industry: string): string {
  return `/validate-ideas?industry=${encodeURIComponent(industry)}`
}

import { resetWindowScroll } from '@/lib/resetWindowScroll'

export const EXPLORE_MORE_HREF = '/validate-ideas'

export { resetWindowScroll as resetExplorePageScroll }
